import React, { useState } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import KanbanCard from './KanbanCard';

const CARDS_PER_PAGE = 25;

function KanbanColumn({ column, leads, onCardClick }) {
  const [visibleCount, setVisibleCount] = useState(CARDS_PER_PAGE);
  const visibleLeads = leads.slice(0, visibleCount);
  const remaining = leads.length - visibleCount;

  return (
    <div className="kanban-column">
      <div
        className="kanban-column-header"
        style={{ borderBottomColor: column.color }}
      >
        <span className="kanban-column-title">{column.title}</span>
        <span className="kanban-column-count">{leads.length}</span>
      </div>
      <Droppable droppableId={column.id}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`kanban-column-cards ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
          >
            {leads.length === 0 ? (
              <div className="kanban-empty-column">No leads</div>
            ) : (
              visibleLeads.map((lead, index) => (
                <KanbanCard
                  key={lead._id}
                  lead={lead}
                  index={index}
                  onClick={onCardClick}
                />
              ))
            )}
            {remaining > 0 && (
              <button
                className="kanban-show-more"
                onClick={() => setVisibleCount(prev => prev + CARDS_PER_PAGE)}
              >
                Show more ({remaining} remaining)
              </button>
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}

export default KanbanColumn;
